import React from 'react';

import { flagStyles } from '../settings';

const SvgSH = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4728px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgSH;
